import { useContext } from 'react';
import AdminAuthContext from '../context/AdminAuthContext'; // Sesuaikan path impor ini jika diperlukan

const useAdminAuth = () => {
  return useContext(AdminAuthContext);
};

export default useAdminAuth;
